import { Injectable, Inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private router: Router, @Inject(DOCUMENT) private document: any) {}
  intercept(request: HttpRequest<any>, next: HttpHandler) {

    request = request.clone({
      setHeaders: {
        Authorization: `${localStorage.getItem('lunge_front')}`,
        // 'domain-h': 'lsfe'
        'domain-h': this.document.location.hostname.split('.')[0].toLowerCase() == 'dreamy-davinci-2f9747' ? 'lsfe': this.document.location.hostname.split('.')[0].toLowerCase()  
      }
    });

    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // do stuff with response if you want
          }
        }, (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401 || err.status === 403) {
              localStorage.removeItem('lunge_front');
              this.router.navigate(['/login']);
            }
          }
        }
      )
    );
  }
}